// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".autocomplete-items{list-style-type:none;padding:0;margin:0;border:1px solid #ccc;display:block}.autocomplete-items li{padding:8px;cursor:pointer}.autocomplete-active,.autocomplete-items li:hover{background-color:#00427a}.autocomplete-active{color:#fff}", ""]);
// Exports
module.exports = exports;
